








































































import { Component, Prop, Vue } from "vue-property-decorator";
import http from "@/axios/http-common";
import PpiVapPage from "@/pages/pemeriksaan_ranap/PpiVapPage.vue";
import PpiIskPage from "@/pages/pemeriksaan_ranap/PpiIskPage.vue";
import PpiIadPage from "@/pages/pemeriksaan_ranap/PpiIadPage.vue";
import PpiIdoPage from "@/pages/pemeriksaan_ranap/PpiIdoPage.vue";

@Component({
  components: {
    PpiVapPage,
    PpiIskPage,
    PpiIadPage,
    PpiIdoPage
  }
})
export default class BundlePpiPage extends Vue {
  @Prop() register!: number;
  @Prop() rm!: number;
  @Prop({ default: false }) isActive!: boolean;

  sections = [
    { key: "vap", label: "Bundle VAP" },
    { key: "isk", label: "Bundle ISK" },
    { key: "iad", label: "Bundle IAD" },
    { key: "ido", label: "Bundle IDO" }
  ];

  printPdf() {
    window.open(`${http.getAPI()}/register/${this.register}/ppi-bundle/pdf`, "_blank");
  }

  scrollTo(key: string) {
    const ref = this.$refs[`section-${key}`] as HTMLElement[] | HTMLElement | undefined;
    const el = Array.isArray(ref) ? ref[0] : ref;
    if (el && typeof el.scrollIntoView === "function") {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }
}
